import React from "react";
import { Link, useLocation } from "react-router-dom";

export const AidaviePagination = ({ aidavieState, pageSearch, routerQuery }) => {
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	return (
		<nav className="flex-row my-3 justify-content-center" aria-label="Page navigation">
			{aidavieState.currentPage > 1 ? (
				<Link
					to={() => {
						searchParams.set("page", "1");
						return `/backoffice/aidavie?${searchParams.toString()}`;
					}}
					className={"btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}>
					<i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i>
				</Link>
			) : (
				<button disabled className={"btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}>
					<i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i>
				</button>
			)}
			{aidavieState.currentPage > 1 ? (
				<Link
					to={() => {
						searchParams.set("page", aidavieState.currentPage - 1);
						return `/backoffice/aidavie?${searchParams.toString()}`;
					}}
					className={"btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}>
					<i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i>
				</Link>
			) : (
				<button disabled className={"btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}>
					<i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i>
				</button>
			)}

			<span className="btn rounded-sm bg-dim px-2 py-1 mx-1 d-flex justify-content-center align-items-center fs-aux">
				{aidavieState.currentPage} de {aidavieState.totalPages}
			</span>
			{aidavieState.currentPage < aidavieState.totalPages ? (
				<Link
					to={() => {
						searchParams.set("page", aidavieState.currentPage + 1);
						return `/backoffice/aidavie?${searchParams.toString()}`;
					}}
					className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
					<i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i>
				</Link>
			) : (
				<button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
					<i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i>
				</button>
			)}
			{aidavieState.currentPage < aidavieState.totalPages ? (
				<Link
					to={() => {
						searchParams.set("page", aidavieState.totalPages);
						return `/backoffice/aidavie?${searchParams.toString()}`;
					}}
					className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
					<i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i>
				</Link>
			) : (
				<button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
					<i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i>
				</button>
			)}
		</nav>
	);
};
